import { useEffect } from "react";

export function Seo({ title, description, keywords, ogImage }) {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (attr, name, content) => {
      if (!content) return;
      let m = document.head.querySelector(`meta[${attr}="${name}"]`);
      if (!m) { m = document.createElement("meta"); m.setAttribute(attr, name); document.head.appendChild(m); }
      m.setAttribute("content", content);
    };
    setMeta("name", "description", description);
    setMeta("name", "keywords", keywords);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:image", ogImage);
    setMeta("property", "og:type", "website");
    setMeta("name", "twitter:card", ogImage ? "summary_large_image" : "summary");
  }, [title, description, keywords, ogImage]);
  return null;
}
